import { useState } from "react";
import { DASHBOARD_USER_TABLE_OPTIONS } from "../../../../constant";
import CustomTabs from "../../../CommonComponents/CustomTabs";
import DataTable from "../../../CommonComponents/DataTable";
import styles from "./UserTable.module.css";
import { Spin } from "antd";

const columns = [
  {
    title: "User ID",
    dataIndex: "_id",
    key: "_id",
  },
  {
    title: "Name",
    dataIndex: "firstName",
    key: "firstName",
    render: (status, record) => {
      return <>{record.firstName + " " + record.lastName} </>;
    },
  },
  {
    title: "Email",
    dataIndex: "emailAddress",
    key: "emailAddress",
    width: "40%",
  },
];

const UserTable = ({ height, data }) => {
  const [filter, setFilter] = useState("Candidates");

  return (
    <div className={styles.content_wrap}>
      <div className={styles.content_header}>
        <div className={styles.label}>Most recently joined</div>
        <CustomTabs
          defaultValue={filter}
          onChange={(value) => setFilter(value)}
          options={DASHBOARD_USER_TABLE_OPTIONS}
        />
      </div>
      {data?.candidates ? (
        <DataTable
          loading={true}
          columns={columns}
          data={filter === "Candidates" ? data?.candidates : data?.enterprise}
          scroll={{
            x: "max-content",
            y: height,
          }}
        />
      ) : (
        <div className={styles.loader_wrap}>
          <Spin />
        </div>
      )}
    </div>
  );
};

export default UserTable;
